import { render, staticRenderFns } from "./table-bar.vue?vue&type=template&id=02906098&scoped=true"
import script from "./table-bar.vue?vue&type=script&lang=js"
export * from "./table-bar.vue?vue&type=script&lang=js"
import style0 from "./table-bar.vue?vue&type=style&index=0&id=02906098&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02906098",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/gameclient/gameclient/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('02906098')) {
      api.createRecord('02906098', component.options)
    } else {
      api.reload('02906098', component.options)
    }
    module.hot.accept("./table-bar.vue?vue&type=template&id=02906098&scoped=true", function () {
      api.rerender('02906098', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/tai-xiu/table-bar.vue"
export default component.exports